import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { nextSteps } from '../data/quotation';
export function NextStepsSection() {
  return <section id="next-steps" className="border-t border-line bg-white py-20 sm:py-28" data-id="element-108" data-mp="2k1ckk3n5q9x9">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-109" data-mp="2p06zuvlx1gcm">
        <SectionHeading eyebrow="Next steps" title="From signature to first Hook & Teaser in ten weeks" description="Sequenced so snak campaigns sit inside the brand strategies and all five EU5 markets are live ahead of the October deadline." data-id="element-110" data-mp="2p0p1y8v9eosg" />

        <ol className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-111" data-mp="32qsjwnn3vwc3">
          {nextSteps.map((step, index) => <motion.li key={step.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="rounded-2xl border border-line bg-white p-6" data-id="element-112" data-mp="37ou3rascvzom" data-mpi={index}>
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary font-display text-sm font-semibold text-white" data-id="element-113" data-mp="23w49ofwtytvv">
                {index + 1}
              </span>
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-114" data-mp="2cviw949vmkb3">
                {step.timing}
              </p>
              <h3 className="mt-2 font-display text-lg font-semibold text-ink-900" data-id="element-115" data-mp="2rrgssnnppqnu">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-500" data-id="element-116" data-mp="30llktael184y">
                {step.body}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}